import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 3;
  background-color: rgb(0,0,0, 0.2);

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentModel = styled.div`
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding: 36px 28px;
    
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    
    -webkit-box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};
    -moz-box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};
    box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};


  @media (max-width: 700px) {
    width: 90%;
  }
`;

export const InfoModel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.colors.black};

  div {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  & span {
    font-weight: bold;
    font-size: 16px;
    padding: 0px;
    margin: 0px;
    color: ${(props) => props.theme.colors.black};
  }

  & small {
    font-weight: 400;
    font-size: 16px;
  }

  svg{
    color: ${(props) => props.theme.colors.warning};
  }
`;

export const Action = styled.div`
  display: flex;
  justify-content: end;
  gap: 20px;

  button {
    padding: 10px;
    border-radius: 10px;
  }
`;